/* Storefront GA4 only. Shopify consent owns eligibility; checkout needs the native integration. */
(function () {
  'use strict';
  if (window.BuonCiboAnalytics || window.top !== window) return;
  var ID = 'G-9Z057TFQ2V';
  var TAG_ID = 'GT-WPFF2QMM'; // Load the existing Google tag; route config and events only to the GA4 destination.
  var disableKey = 'ga-disable-' + ID;
  var sdk = 'idle';
  var configured = false;
  var pageSent = false;
  var privacyLoading = false;
  var consentEpoch = 0;
  var queue = [];
  var leadIds = new Set();
  var cartResponses = new WeakSet();
  var context = {};
  var CAMPAIGNS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'];
  var FORMS = { catering: 'catering_request', private_room: 'private_room_request', general_contact: 'contact_message', other_events: 'event_inquiry' };
  var SOURCE_PATHS = ['', '/', '/contact', '/pages/contact', '/pages/catering', '/pages/private-room', '/pages/wine-events', '/pages/charcuterie'];
  window[disableKey] = true;

  try { context = JSON.parse(document.getElementById('bc-ga4-context').textContent); } catch (_) {}

  function allowed() {
    if (navigator.globalPrivacyControl === true || document.prerendering || window.Shopify && window.Shopify.designMode) return false;
    if (/^\/(?:account|checkout|checkouts|challenge|password)(?:\/|$)/.test(window.location.pathname)) return false;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!cp && cp.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }

  function safeUrl(raw, campaign) {
    try {
      var input = new URL(raw, window.location.origin);
      if (!/^https?:$/.test(input.protocol)) return '';
      // Referrer needs the origin for attribution, not its path, search terms or fragment.
      if (!campaign) return input.origin + '/';
      var output = new URL(input.origin);
      output.pathname = /^\/[A-Za-z0-9/_-]{0,400}$/.test(input.pathname) ? input.pathname : '/';
      CAMPAIGNS.forEach(function (key) {
        var value = input.searchParams.get(key);
        // Campaign labels only. Reject URLs, email addresses, encoded payloads and long free text.
        if (value && /^[A-Za-z0-9][A-Za-z0-9 _.-]{0,99}$/.test(value)) output.searchParams.set(key, value);
      });
      return output.href;
    } catch (_) { return ''; }
  }

  function page() {
    return {
      page_location: safeUrl(window.location.href, true),
      page_referrer: document.referrer ? safeUrl(document.referrer, false) : '',
      page_title: typeof context.title === 'string' ? context.title.slice(0, 200) : 'Buon Cibo'
    };
  }

  function tag() { window.dataLayer.push(arguments); }
  function consent(granted) {
    return { analytics_storage: granted ? 'granted' : 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };
  }

  function send(name, data) {
    if (!allowed() || !configured || window[disableKey]) return false;
    tag('event', name, Object.assign({}, page(), data, { send_to: ID }));
    return true;
  }

  function drain() {
    if (!allowed() || !configured) return;
    var events = queue.splice(0);
    events.forEach(function (event) { send(event.name, event.data); });
  }

  function productView() {
    var item = context.product;
    if (context.page_type !== 'product' || !item || !/^\d+$/.test(String(item.item_id)) || !Number.isFinite(item.price) || item.price < 0 || !/^[A-Z]{3}$/.test(context.currency)) return;
    var data = { item_id: String(item.item_id), item_name: String(item.item_name).slice(0, 200), item_variant: String(item.item_variant).slice(0, 100), price: item.price, quantity: 1 };
    if (/^(friday_dinner|lasagna_sunday|sunday_brunch|wine_events|catering|other_products)$/.test(context.program)) data.item_category = context.program;
    send('view_item', { currency: context.currency, value: item.price, items: [data] });
  }

  function activate() {
    if (!allowed() || sdk !== 'ready') return;
    window[disableKey] = false;
    if (!configured) {
      var values = Object.assign({}, page(), { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
      tag('consent', 'update', consent(true));
      tag('set', values);
      tag('config', ID, values);
      configured = true;
    } else tag('consent', 'update', consent(true));
    if (!pageSent) {
      pageSent = true;
      send('page_view', {});
      productView();
    }
    drain();
  }

  function start() {
    if (!allowed()) return;
    if (sdk === 'ready') { activate(); return; }
    if (sdk !== 'idle') return;
    if (typeof window.gtag === 'function' || document.querySelector('script[src*="googletagmanager.com/gtag/js"], script[src*="googletagmanager.com/gtm.js"]')) {
      sdk = 'duplicate_tag_detected';
      return;
    }
    sdk = 'loading';
    // No Google data layer, SDK, request or storage exists from this module before eligibility.
    window.dataLayer = window.dataLayer || [];
    window.gtag = tag;
    tag('consent', 'default', consent(false));
    tag('set', 'ads_data_redaction', true);
    tag('set', 'url_passthrough', false);
    tag('js', new Date());
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + TAG_ID;
    script.referrerPolicy = 'origin';
    script.onload = function () { sdk = 'ready'; activate(); };
    script.onerror = function () { sdk = 'failed'; queue = []; };
    document.head.appendChild(script);
  }

  function enqueue(name, data) {
    if (!allowed() || sdk === 'failed') return false;
    start();
    if (sdk !== 'loading' && sdk !== 'ready') return false;
    if (sdk === 'ready' && configured) return send(name, data);
    if (queue.length >= 20) return false;
    queue.push({ name: name, data: data });
    return true;
  }

  function lead(payload) {
    if (!allowed() || !payload || payload.schema_version !== 1 || payload.analytics_consent_at_submit !== true ||
        !/^bc_lead_[a-f0-9-]{32,36}$/.test(payload.event_id) || !FORMS[payload.program] || FORMS[payload.program] !== payload.form_id ||
        SOURCE_PATHS.indexOf(payload.source_path) === -1 || payload.success_path !== '/pages/contact') return false;
    if (leadIds.has(payload.event_id)) return true;
    var accepted = enqueue('generate_lead', { event_id: payload.event_id, form_id: payload.form_id, program: payload.program, lead_type: 'inquiry', source_path: payload.source_path });
    if (accepted) leadIds.add(payload.event_id);
    return accepted;
  }

  function trackAddToCart(responseItems, requestedItems, onComplete) {
    if (!allowed() || !responseItems || typeof responseItems !== 'object' || !Array.isArray(requestedItems) || !requestedItems.length || requestedItems.length > 50) return false;
    if (cartResponses.has(responseItems)) return true;
    var response = Array.isArray(responseItems) ? responseItems : [responseItems];
    var quantities = {};
    for (var i = 0; i < requestedItems.length; i += 1) {
      var request = requestedItems[i];
      if (!request || typeof request !== 'object') return false;
      var id = String(request.id);
      var quantity = Number(request.quantity == null ? 1 : request.quantity);
      if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1 || quantity > 1000) return false;
      quantities[id] = (quantities[id] || 0) + quantity;
    }
    var items = [];
    var value = 0;
    var ids = Object.keys(quantities);
    for (var j = 0; j < ids.length; j += 1) {
      var variantId = ids[j];
      var item = response.find(function (entry) { return entry && String(entry.variant_id || entry.id) === variantId; });
      var cents = item && (item.final_price != null ? item.final_price : item.price);
      if (!item || typeof cents !== 'number' || !Number.isFinite(cents) || cents < 0) return false;
      if (response.some(function (entry) { return entry && String(entry.variant_id || entry.id) === variantId && (entry.final_price != null ? entry.final_price : entry.price) !== cents; })) return false;
      var row = { item_id: variantId, item_name: String(item.product_title || item.title || '').slice(0, 200), item_variant: String(item.variant_title || '').slice(0, 100), price: cents / 100, quantity: quantities[variantId] };
      items.push(row);
      value += row.price * row.quantity;
    }
    if (!/^[A-Z]{3}$/.test(context.currency)) return false;
    var data = { currency: context.currency, value: Math.round(value * 100) / 100, items: items };
    if (typeof onComplete === 'function') {
      data.event_callback = onComplete;
      data.event_timeout = 700;
    }
    var accepted = enqueue('add_to_cart', data);
    if (accepted) cartResponses.add(responseItems);
    return accepted;
  }

  function privacyChanged() {
    if (!allowed()) {
      consentEpoch += 1;
      // The documented disable switch prevents further collection, including SDK-generated events.
      window[disableKey] = true;
      queue = [];
      if (sdk === 'loading' || sdk === 'ready' || sdk === 'failed') tag('consent', 'update', consent(false));
      return;
    }
    start();
  }

  function ready() {
    privacyChanged();
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function' && !privacyLoading) {
      privacyLoading = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { privacyLoading = false; privacyChanged(); });
      } catch (_) { privacyLoading = false; }
    }
  }
  window.BuonCiboAnalytics = Object.freeze({ lead: lead, trackAddToCart: trackAddToCart, status: function () { return { sdk: sdk, allowed: allowed(), configured: configured, queued: queue.length }; } });
  // Horizon emits this before its request. Only its resolved success promise proves an addition.
  // Custom Buon Cibo cart flows call trackAddToCart directly and do not emit this event.
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (!allowed() || !event || event.action !== 'add' || !Array.isArray(event.lines) || !event.promise || typeof event.promise.then !== 'function') return;
    var epoch = consentEpoch;
    var requests = event.lines.map(function (line) {
      return { id: String(line && line.merchandiseId || '').replace(/^gid:\/\/shopify\/ProductVariant\//, ''), quantity: line && line.quantity };
    });
    Promise.resolve(event.promise).then(function (result) {
      var detail = result && result.detail;
      if (epoch !== consentEpoch || !allowed() || !detail || detail.didError !== false || detail.source !== 'product-form-component' || !Array.isArray(detail.items)) return;
      trackAddToCart(detail.items, requests);
    }).catch(function () { /* Failed additions and failed refreshes are not conversions. */ });
  });
  document.addEventListener('visitorConsentCollected', privacyChanged);
  document.addEventListener('prerenderingchange', ready);
  window.addEventListener('pageshow', ready);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
